module.exports = __webpack_public_path__ + "img/tu08.0eee6a26.png";